define( [
	"../var/support"
], function( support ) {

"use strict";

support.focusin = "onfocusin" in window;

return support;

} );



//////////////////
// WEBPACK FOOTER
// ./~/_jquery@3.6.0@jquery/src/event/support.js
// module id = 1157
// module chunks = 0